module.exports = __webpack_public_path__ + "static/media/ic_light_open.8cc3a76a.png";